import FormInput from "./FormInput";
import FormTextarea from "./FormTextarea";

export default function OfferedItemsInput({ items, onChange }) {
    const updateItem = (id, field, value) => {
        const updated = items.map((item) =>
            item.id === id ? { ...item, [field]: value } : item
        );
        onChange(updated);
    };

    const updateKeyPoint = (id, index, value) => {
        const updated = items.map((item) => {
            if (item.id !== id) return item;

            const keyPoints = [...item.keyPoints];
            keyPoints[index] = value;
            return { ...item, keyPoints };
        });

        onChange(updated);
    };

    const addKeyPoint = (id) => {
        const updated = items.map((item) =>
            item.id === id
                ? { ...item, keyPoints: [...item.keyPoints, ""] }
                : item
        );
        onChange(updated);
    };

    const removeKeyPoint = (id, index) => {
        const updated = items.map((item) => {
            if (item.id !== id) return item;

            const keyPoints = item.keyPoints.filter((_, i) => i !== index);
            return { ...item, keyPoints: keyPoints.length ? keyPoints : [""] };
        });

        onChange(updated);
    };

    const addItem = () => {
        onChange([
            ...items,
            {
                id: crypto.randomUUID(),
                name: "",
                subtitle: "",
                description: "",
                badge: "",
                category: "",
                audience: "",
                level: "",
                imagePreference: "",
                keyPoints: [""]
            }
        ]);
    };

    const removeItem = (id) => {
        const updated = items.filter((item) => item.id !== id);
        onChange(updated.length ? updated : [
            {
                id: crypto.randomUUID(),
                name: "",
                subtitle: "",
                description: "",
                badge: "",
                category: "",
                audience: "",
                level: "",
                imagePreference: "",
                keyPoints: [""]
            }
        ]);
    };

    return (
        <div>
            <div className="wg-section-head-row">
                <div>
                    <h3 className="wg-section-title">Programs / Products / Offerings</h3>
                    <p className="wg-section-subtitle">
                        Add the main items this business offers. These help generate better showcase sections, pages, and visual direction.
                    </p>
                </div>

                <button
                    type="button"
                    className="wg-btn secondary"
                    onClick={addItem}
                >
                    + Add Item
                </button>
            </div>

            <div className="wg-stack">
                {items.map((item, itemIndex) => (
                    <div key={item.id} className="wg-card">
                        <div className="wg-card-topbar">
                            <strong>Item {itemIndex + 1}</strong>
                            <button
                                type="button"
                                className="wg-btn danger"
                                onClick={() => removeItem(item.id)}
                            >
                                Remove
                            </button>
                        </div>

                        <div className="wg-form-grid">
                            <FormInput
                                label="Name"
                                value={item.name}
                                onChange={(v) => updateItem(item.id, "name", v)}
                            />

                            <FormInput
                                label="Subtitle"
                                value={item.subtitle}
                                onChange={(v) => updateItem(item.id, "subtitle", v)}
                            />

                            <FormInput
                                label="Badge"
                                value={item.badge}
                                onChange={(v) => updateItem(item.id, "badge", v)}
                            />

                            <FormInput
                                label="Category"
                                value={item.category}
                                onChange={(v) => updateItem(item.id, "category", v)}
                            />

                            <FormInput
                                label="Audience / Age Group"
                                value={item.audience}
                                onChange={(v) => updateItem(item.id, "audience", v)}
                            />

                            <FormInput
                                label="Level / Type"
                                value={item.level}
                                onChange={(v) => updateItem(item.id, "level", v)}
                            />

                            <FormInput
                                label="Image Preference"
                                value={item.imagePreference}
                                onChange={(v) => updateItem(item.id, "imagePreference", v)}
                            />

                            <FormTextarea
                                label="Description"
                                value={item.description}
                                onChange={(v) => updateItem(item.id, "description", v)}
                            />
                        </div>

                        <div className="wg-subsection">
                            <div className="wg-subsection-header">
                                <strong>Key Points</strong>
                                <button
                                    type="button"
                                    className="wg-btn secondary"
                                    onClick={() => addKeyPoint(item.id)}
                                >
                                    + Add Point
                                </button>
                            </div>

                            <div className="wg-stack-sm">
                                {item.keyPoints.map((point, pointIndex) => (
                                    <div key={`${item.id}-point-${pointIndex}`} className="wg-inline-row">
                                        <input
                                            className="wg-input"
                                            placeholder={`Point ${pointIndex + 1}`}
                                            value={point}
                                            onChange={(e) =>
                                                updateKeyPoint(item.id, pointIndex, e.target.value)
                                            }
                                        />
                                        <button
                                            type="button"
                                            className="wg-btn danger"
                                            onClick={() => removeKeyPoint(item.id, pointIndex)}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}